import { Stack } from '@mantine/core';
import { ReactNode } from 'react';

type props = {
  children?: ReactNode;
  parentStepsCount?: number;
  topOffset?: number;
};

const StepCardPill = ({ children, parentStepsCount = 0, topOffset }: props) => {
  const left = `-${parentStepsCount * 17 + 16}px`;

  return (
    <Stack
      h="63px"
      style={{ position: 'absolute', left: left, transform: 'translateX(-100%)' }}
      justify={'center'}
      mt={topOffset}
    >
      {children}
    </Stack>
  );
};

export default StepCardPill;
